import request from '@/utils/request'
export function getInfos(params) {
    return request({
        url: '/getPcInfo',
        method: 'get',
        params
    })
}
// 查询院系专业列表
export function listSubject(query) {
    return request({
      url: '/business/subject/list',
      method: 'get',
      params: query
    })
  }
// 查询班级管理列表
export function listClass(query) {
    return request({
      url: '/business/class/list',
      method: 'get',
      params: query
    })
}
// 修改账号密码
export function updatePwd(params) {
    return request({
        url: '/system/user/profile/updatePwd',
        method: 'put',
        data: params,
        header: {
            "Content-Type": 'application/x-www-form-urlencoded'
        }
    })
}
//修改信息
export function updateInfo(params) {
    return request({
        url: '/updatePcUserInfo',
        method: 'post',
        data: params,
      
    })
}
//上传头像
export function uploadAvatar(params) {
    return request({
      url: '/upload/uploadOther',
      method: 'post',
      data: params,
    })
}
